import React from 'react';
// import Prof from '../components/Faculty/Prof';
import Faculties from '../components/Faculty/Faculties';

function Faculty() {
  return (
    <div className='faculty-head'>
      <Faculties />
    </div>
  )
}

export default Faculty
